import { useState, useEffect } from 'react';

const useImageDownload = (imageData) => {
    const [file, setFile] = useState(null);

    useEffect(() => {
        if (imageData && imageData.image_blob) {
            const byteCharacters = atob(imageData.image_blob);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'image/jpeg' });
            const fileName = imageData.secure_name || 'insurance_card.jpg';
            setFile(new File([blob], fileName, { type: 'image/jpeg' }));
        } else {
            setFile(null);
        }
    }, [imageData]);

    return file;
};

export default useImageDownload;